import React from "react";
import { Icon } from "@qgiv/core-react";
import cx from "classnames";

/**
 * @param {object} props
 * @param {boolean} props.noLeftGutter
 * @param {string} props.teaserLabel
 * @returns {React.JSX.Element}
 */
const EmployerMatchingTeaser = ({ noLeftGutter, teaserLabel }) => (
    <div className={cx("col col--12", noLeftGutter && "-padding-left--0")}>
        <div className="-callout -padding-left--15">
            <Icon
                ariaHidden
                className="-type--xxlarge"
                glyph="gifts-duotone"
                type="FontAwesome"
            />
            <span className="-margin-left--10 -type--regular ">
                {teaserLabel}
            </span>
        </div>
    </div>
);

export default EmployerMatchingTeaser;
